<template>
  <div class="transfer-container">
    <el-dialog
      :visible.sync="dialogFormTransfer"
      :close-on-click-modal="false"
      :width="device === 'mobile' ? '95%' : ''"
      top="5vh"
    >
      <el-tabs>
        <el-tab-pane :label="`Transfer`">
          <el-form
            :model="TransferForm"
            ref="TransferForm"
            label-width="170px"
            size="small"
            :rules="TransferFormRule"
            :label-position="device === 'mobile' ? 'top' : 'right'"
          >
            <el-form-item label="From BankholderID" prop="bankholderIDFrom">
              <el-input v-model="TransferForm.bankholderIDFrom"></el-input>
            </el-form-item>
            <el-form-item label="To BankholderID" prop="bankholderIDTo">
              <el-input v-model="TransferForm.bankholderIDTo"></el-input>
            </el-form-item>
            <el-form-item label="Amount" prop="amount">
              <el-input type="number" v-model="TransferForm.amount"></el-input>
            </el-form-item>
            <el-form-item label="Currency" prop="currency">
              <el-input
                v-model="TransferForm.currency"
                readonly="readonly"
              ></el-input>
            </el-form-item>
                                  
            <el-form-item label="Crediting Note" prop="creditingNote">
              <el-select v-model="TransferForm.creditingNote" placeholder="Please select note">
                <el-option label="Internal Prefund/Liquidity Transfer" value="Internal Prefund/Liquidity Transfer"></el-option>
                <el-option label="Internal Commission Transfer" value="Internal Commission Transfer"></el-option>
                <el-option label="Customer Order Payment" value="Customer Order Payment"></el-option>
                <el-option label="Reconciliation accounting" value="Reconciliation accounting"></el-option>
                <el-option label="Clear Balance for closing account" value="Clear Balance for closing account"></el-option>
              </el-select>
            </el-form-item>

          <el-form-item>
            <el-button @click="dialogFormTransfer = false">Cancel</el-button>
            <el-button
              type="primary"
              :loading="submitingTransfer"
              @click="submitTransfer()"
              >Submit</el-button
            >
          </el-form-item>
          </el-form>
        </el-tab-pane>

        
        <el-tab-pane :label="`Topup ${ currency && currency.toUpperCase() } (Test)`" v-if="superRole">
          <el-form
            :model="topupForm"
            id="topupForm"
            ref="topupForm"
            label-width="150px"
            size="small"
            :rules="topupFormRules"
            :label-position="device === 'mobile' ? 'top' : 'right'"
          >
            <el-form-item label="Amount" prop="amount">
              <el-input
                type="number"
                v-model="topupForm.amount"
                autocomplete="off"
              ></el-input>
            </el-form-item>

            <el-form-item>
              <el-button
                :loading="submitingTopup"
                type="primary"
                @click="submitTopup()"
                >Submit</el-button
              >
              <el-button @click="dialogFormTransfer = false">Cancel</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>

      </el-tabs>
    </el-dialog>
  </div>
</template>

<script>
import { topupBankAccount, agentTransfer } from "@/api/bank-account";
export default {
  computed: {
    device() {
      return this.$store.state.app.device;
    },
    superRole(){
      return this.roleAuth([this.role.spadmin])
    }
  },
  data() {
    return {
      dialogFormTransfer: false,
      submitingTopup: false,
      submitingTransfer: false,

      currency: "",
      TransferForm: {
        currency: "",
        amount: 0,
        bankholderIDTo: "",
        bankholderIDFrom: "",
        creditingNote: ""
      },
      topupForm: {
        bankholderID: "",
        amount: 0,
      },
      TransferFormRule: {
        currency: [
          {
            required: true,
            message: "Please select Currency",
            trigger: "blur",
          },
        ],
        amount: [
          {
            required: true,
            message: "Please enter Amount",
            trigger: "blur",
          },
          {
            min: 1,
            message: "Please enter Amount",
            trigger: "blur",
          },
        ],
        bankholderIDFrom: [
          {
            required: true,
            message: "Please enter From BankholderID",
            trigger: "blur",
          },
        ],
        bankholderIDTo: [
          {
            required: true,
            message: "Please enter To BankholderID",
            trigger: "blur",
          },
        ],
        creditingNote: [
          {
            required: true,
            message: "Please select note",
            trigger: "blur",
          },
        ]
      },
      topupFormRules: {
        amount: [
          {
            required: true,
            message: "Please enter Amount",
            trigger: "blur",
          },
          {
            min: 1,
            message: "Please enter Amount",
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    showDialogTransfer(bankholderID = "0000001", currency) {
      if (this.$refs.TransferForm) this.$refs.TransferForm.resetFields();
      this.dialogFormTransfer = true;
      this.TransferForm.bankholderIDFrom = bankholderID;
      this.TransferForm.currency = currency.toUpperCase();
      this.topupForm.bankholderID = bankholderID;
      this.currency = currency
    },
    submitTransfer() {
      this.$refs.TransferForm.validate((valid) => {
        if (valid) {
          this.submitingTransfer = true;

          agentTransfer(this.TransferForm).then(({result})=>{
            this.submitingTransfer = false
            if(result){
              this.dialogFormTransfer = false
              this.$notify({
                title: 'Success',
                message: `Payment successfully`,
                type: 'success'
              });
              this.$emit('submited')
            }
          })
        }
      });
    },
    submitTopup() {
      this.$refs.topupForm.validate((valid) => {
        if (valid) {
          this.submitingTopup = true;
          topupBankAccount(this.topupForm.bankholderID, this.topupForm).then(
            ({ result, data }) => {
              if (result) {
                this.$notify({
                  title: "Success",
                  message: `Topup ${this.topupForm.amount} Bank account successfully`,
                  type: "success",
                  duration: 2000
                });
                this.dialogFormTransfer = false;
                this.submitingTopup = false;
                this.$emit("submited");
              }
            }
          );
        }
      });
    },
  },
};
</script>

<style lang="scss">
.transfer-container{
  .el-dialog__body {
    padding: 10px;
  }
  .el-tab-pane {
    padding: 20px;
  }
}
</style>